<kl-survey-members-stream
  [overRideDefaultSurveyMemberDialog]="showAddSurveyMembersDialog">
</kl-survey-members-stream>
